import { createFileRoute, redirect } from "@tanstack/react-router";

import { JoinBoardStep } from "~/pages/onboard/steps/join-board-step";

/**
 * Onboarding wizard variant of `/join/board?id=...`.
 *
 * Gating:
 * - No session         -> /login
 * - Profile incomplete -> /onboard/user
 * - Email unverified   -> /onboard/verify-email
 * - Already onboarded  -> /join/board?id=...
 * - Otherwise          -> render the board invite step
 */
export const Route = createFileRoute("/onboard/join-board/$id")({
  beforeLoad: ({ context, params }) => {
    if (!context.user) {
      throw redirect({ to: "/login", replace: true });
    }
    switch (context.user.onboarding) {
      case "user":
        throw redirect({ to: "/onboard/user", replace: true });
      case "verifyEmail":
        throw redirect({ to: "/onboard/verify-email", replace: true });
      case "done":
        throw redirect({
          to: "/join/board",
          search: { id: params.id },
          replace: true,
        });
      case "invitations":
      case "workspace":
        return;
      default:
        throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: JoinBoardStep,
});
